import React from 'react';

const cx = (...parts) => parts.filter(Boolean).join(' ');

export function SwissPage({ children, className = '' }) {
  return <div className={cx('ff-page', className)}>{children}</div>;
}

export function SwissPanel({ children, className = '', muted = false, staticPanel = true, padding = true }) {
  return (
    <section
      className={cx(
        'ff-card',
        staticPanel && 'ff-card--static',
        muted && 'ff-card--muted',
        'ff-swiss-panel',
        className
      )}
    >
      <div className={cx(padding && 'ff-swiss-panel__body')}>{children}</div>
    </section>
  );
}

export function SwissSectionHeader({
  label,
  title,
  subtitle,
  actions = null,
  className = '',
  as: Heading = 'h2',
  size = 'section',
}) {
  return (
    <div className={cx('ff-section-header', size === 'page' && 'ff-section-header--page', className)}>
      <div className="ff-section-header__copy">
        {label ? <div className="ff-label ff-section-header__kicker">{label}</div> : null}
        {title ? <Heading className="ff-page__section-title ff-section-header__title">{title}</Heading> : null}
        {subtitle ? <p className="ff-subtle ff-section-header__lead">{subtitle}</p> : null}
      </div>
      {actions ? <div className="ff-section-header__actions">{actions}</div> : null}
    </div>
  );
}

export function SwissTableFrame({ children, className = '' }) {
  return <div className={cx('ff-table-frame', className)}>{children}</div>;
}

export function SwissNotice({ children, className = '', accent = false }) {
  return <div className={cx('ff-notice', accent && 'ff-notice--accent', className)}>{children}</div>;
}

export function SwissInlineMeta({ children, className = '' }) {
  return <div className={cx('ff-inline-meta', className)}>{children}</div>;
}

export function SwissButton({ children, className = '', variant = 'primary', as: Comp = 'button', ...props }) {
  // "dark" was visually identical to primary; it maps to primary for backwards compatibility.
  const variantClass = variant === 'ghost' ? 'ff-button-ghost' : 'ff-button';
  return (
    <Comp className={cx(variantClass, className)} {...props}>
      {children}
    </Comp>
  );
}
